import { useContext } from "react";
import {
  IntroducingBrokerMemberHistoryParams,
  UserHistoryResponse,
} from "@letsbit/malcolmlb";

import { ApiContext } from "providers/ApiProvider";
import {
  useAuthInfiniteSWR,
  SWRInfiniteResponseCustom,
} from "hooks/utils/useAuthSWR";
export const GET_HISTORY_LIMIT = 100;
export const SWR_INTRODUCING_MEMBER_MEMBER_HISTORY_KEY =
  "get-introducing-broker-member-history";

export const useIntroducingBrokerMemberHistory = (
  params?: IntroducingBrokerMemberHistoryParams,
): SWRInfiniteResponseCustom<UserHistoryResponse[]> => {
  const { memberInstance } = useContext(ApiContext);
  const swr = useAuthInfiniteSWR(
    [SWR_INTRODUCING_MEMBER_MEMBER_HISTORY_KEY, params],
    async (withPage): Promise<UserHistoryResponse[]> => {
      const { data } = await memberInstance.partner.getMemberHistoryPlatform(
        withPage[0][1],
      );
      return data;
    },
  );
  return swr;
};
